import styled from "@emotion/styled";

import { ActionModal } from "@livechat/design-system";
import { Modal } from "@livechat/design-system-react-components";

export const AdaptedActionModal = styled(ActionModal)`
  max-width: 100%;
  max-height: 90%;
  min-width: 0;
  @media (min-width: 400px) {
    min-width: 400px;
  }

  .lc-action-modal__content {
    overflow: auto;
  }
`;

/**
 * Modal from Design System has min-width set to 400px which is inconvenient for small mobiles like 320px.
 * Additionally we make content part scrollable.
 * Use this adapted component until we fix that in design-system.
 */
export const AdaptedModal = styled(Modal)`
  max-width: 100%;
  max-height: 90%;
  box-sizing: border-box;

  min-width: 0;
  @media (min-width: 400px) {
    min-width: 400px;
  }
`;
